import React, { useContext } from 'react'
import { StepHeading, StepDescription, Form } from 'components/GetStarted/styles'
import { getHeadingForUserType } from 'utils/getStartedUtils'
import PrimaryButton from 'components/generic/PrimaryButton'
import { useForm } from 'react-hook-form'
import { trackClickEvent } from 'utils/Analytics'
import CheckboxInput from 'components/generic/Input/CheckboxInput'
import { AppContext } from 'contexts/AppContext'

const StepServices = ({ data, userInput, onStepComplete }) => {
  const { domain } = useContext(AppContext)
  const { handleSubmit, register, formState } = useForm({
    mode: 'onChange',
    defaultValues: {
      services: userInput?.services,
    },
  })
  const { isValid } = formState
  const facetQuestions = data?.site?.facet_questions?.[0]
  const questions = facetQuestions?.answer_facets ?? []
  const heading = getHeadingForUserType({
    userType: userInput?.user_type,
    providerHeading: facetQuestions?.provider_question,
    seekerHeading: facetQuestions?.seeker_question,
    defaultHeading: 'What are the services?',
  })
  return (
    <Form onSubmit={handleSubmit(onStepComplete)}>
      <StepHeading>{heading}</StepHeading>
      <StepDescription>Select all that apply</StepDescription>
      {questions.map((question) => (
        <CheckboxInput
          key={question.name}
          name='services'
          value={question.name}
          label={question.description}
          ref={register({ required: true })}
        />
      ))}
      <PrimaryButton
        mt='2rem'
        disabled={!isValid}
        onClick={() => trackClickEvent(domain, 'get-started-next-services')}
      >
        Next
      </PrimaryButton>
    </Form>
  )
}

export default StepServices
